module.exports = __webpack_public_path__ + "static/school-2dc0a7423a8165d55fc5d16ff6338854.png";